define('Store.Model', [
    'Backbone.CachedModel',
    'underscore'
], function StoreModel(
    BackboneCachedModel,
    _
) {
    'use strict';

    return BackboneCachedModel.extend({
        urlRoot: _.getAbsoluteUrl('services/Store.Service.ss')
    });
});
